import { humanizeDate } from '@/utilities/formatters';

const mixin = {
  methods: {
    $_formatDate(date, format) {
      return humanizeDate(date, format);
    },
  },
};

export default mixin;
